module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('main', {
    staticClass: "flex flex-column justify-center self-center center-ns mb4 main-container"
  }, [_c('akko-header'), _vm._v(" "), _c('div', {
    staticClass: "circle"
  }), _vm._v(" "), (_vm.spin) ? _c('div') : _c('div', [(this.isFirstStep) ? _c('div', {
    staticClass: "flex responsive",
    class: _vm.existsData.includes(true) ? 'justify-between' : 'justify-center'
  }, [_c('div', {
    staticClass: "flex flex-column w-65 responsive-choose-plan",
    class: _vm.existsData.includes(true) ? '' : _vm.is3cRegistration ? 'items-center' : ''
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.showPlans),
      expression: "showPlans"
    }]
  }, [(_vm.is3cRegistration) ? _c('select-plan-3c-vue', {
    attrs: {
      "completeData": _vm.existsData,
      "isPhoneOnly": _vm.isPhoneOnly,
      "setValue": _vm.setIsPhoneOnly
    }
  }) : _c('select-plan', {
    attrs: {
      "isPhoneOnly": _vm.isPhoneOnly,
      "setValue": _vm.setIsPhoneOnly
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "devices-div"
  }, [_c('select-devices', {
    attrs: {
      "addPhone": _vm.addPhone,
      "allMakes": _vm.allMakes,
      "completeData": _vm.existsData,
      "filterModelsBySelectedMake": _vm.filterModelsBySelectedMake,
      "is3cRegistration": _vm.is3cRegistration,
      "isFamily": _vm.isFamily,
      "isPhoneOnly": _vm.isPhoneOnly,
      "removePhone": _vm.removePhone,
      "selectedPhones": _vm.selectedPhones,
      "setIsAdult": _vm.setIsAdult,
      "setMake": _vm.setMake,
      "setModel": _vm.setModel,
      "specificDeductibles": _vm.coverageAkkoPlan.total,
      "showPlans": _vm.showPlans
    },
    on: {
      "update:selectedPhones": function($event) {
        _vm.selectedPhones = $event
      },
      "update:selected-phones": function($event) {
        _vm.selectedPhones = $event
      }
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "mb4 flex flex-wrap flex-column responsive-box w-35",
    class: _vm.is3cRegistration ? _vm.existsData.includes(true) ? '' : 'visibility' : ''
  }, [(_vm.is3cRegistration) ? _c('new-summary-card-3c-vue', {
    attrs: {
      "completeData": _vm.existsData,
      "filteredPhones": _vm.filteredPhones,
      "generalDeductibles": _vm.coverageAkkoPlan.deductible,
      "isFamily": _vm.isFamily,
      "isPhoneOnly": _vm.isPhoneOnly,
      "monthlyToggle": _vm.monthlyToggle,
      "disableIntervalToggle": _vm.disableIntervalToggle,
      "name": _vm.coverageName,
      "price": _vm.totalPrice,
      "selectedCoverages": _vm.monthlyToggle ? _vm.selectedMonthlyCoverages : _vm.selectedAnnualCoverages,
      "setMonthly": _vm.setMonthly,
      "specificDeductibles": _vm.coverageAkkoPlan.total,
      "conversionCaption": "Proceed to Checkout",
      "planType": "PHONE"
    },
    on: {
      "click": _vm.nextStep
    }
  }) : _c('new-summary-card', {
    attrs: {
      "completeData": _vm.existsData,
      "filteredPhones": _vm.filteredPhones,
      "generalDeductibles": _vm.coverageAkkoPlan.deductible,
      "isFamily": _vm.isFamily,
      "isPhoneOnly": _vm.isPhoneOnly,
      "monthlyToggle": _vm.monthlyToggle,
      "disableIntervalToggle": _vm.disableIntervalToggle,
      "name": _vm.coverageName,
      "price": _vm.totalPrice,
      "selectedCoverages": _vm.monthlyToggle ? _vm.selectedMonthlyCoverages : _vm.selectedAnnualCoverages,
      "setMonthly": _vm.setMonthly,
      "specificDeductibles": _vm.coverageAkkoPlan.total,
      "conversionCaption": "Proceed to Checkout",
      "planType": "PHONE"
    },
    on: {
      "click": _vm.nextStep
    }
  })], 1)]) : _c('div', {
    staticClass: "mt6 flex responsive",
    class: _vm.is3cRegistration ? 'justify-center' : 'justify-between'
  }, [(_vm.is3cRegistration) ? _c('unified-checkout', {
    ref: "cardForm",
    attrs: {
      "cardFirstName": _vm.cardFirstName,
      "cardLastName": _vm.cardLastName,
      "postalCode": _vm.postalCode,
      "creditCardCompleted": _vm.creditCardCompleted,
      "disabledButton": _vm.secondStepDisabled,
      "email": _vm.email,
      "filteredPhones": _vm.filteredPhones,
      "hasAgreed": _vm.hasAgreed,
      "isBankDataFilled": _vm.isBankDataFilled,
      "isBiggerCoupon": _vm.isBiggerCoupon,
      "isCreditCard": _vm.isCreditCard,
      "isFirstStep": _vm.isFirstStep,
      "isStudent": _vm.studentQuantity > 0,
      "monthlyToggle": _vm.monthlyToggle,
      "disableIntervalToggle": _vm.disableIntervalToggle,
      "onSubmit": _vm.submit,
      "price": _vm.totalPrice,
      "secondStepDevices": _vm.secondStepDevices,
      "setMonthly": _vm.setMonthly,
      "totalMultiPlanDiscount": _vm.totalMultiPlanDiscount,
      "totalPriceWithoutDiscount": _vm.totalPriceWithoutDiscount,
      "coverages": _vm.monthlyToggle ? _vm.selectedMonthlyCoverages : _vm.selectedAnnualCoverages,
      "setPrimaryPhone": _vm.setPrimaryPhone
    },
    on: {
      "update:cardFirstName": function($event) {
        _vm.cardFirstName = $event
      },
      "update:card-first-name": function($event) {
        _vm.cardFirstName = $event
      },
      "update:cardLastName": function($event) {
        _vm.cardLastName = $event
      },
      "update:card-last-name": function($event) {
        _vm.cardLastName = $event
      },
      "update:postalCode": function($event) {
        _vm.postalCode = $event
      },
      "update:postal-code": function($event) {
        _vm.postalCode = $event
      },
      "update:creditCardCompleted": function($event) {
        _vm.creditCardCompleted = $event
      },
      "update:credit-card-completed": function($event) {
        _vm.creditCardCompleted = $event
      },
      "update:email": function($event) {
        _vm.email = $event
      },
      "update:hasAgreed": function($event) {
        _vm.hasAgreed = $event
      },
      "update:has-agreed": function($event) {
        _vm.hasAgreed = $event
      },
      "update:isBiggerCoupon": function($event) {
        _vm.isBiggerCoupon = $event
      },
      "update:is-bigger-coupon": function($event) {
        _vm.isBiggerCoupon = $event
      },
      "update:isCreditCard": function($event) {
        _vm.isCreditCard = $event
      },
      "update:is-credit-card": function($event) {
        _vm.isCreditCard = $event
      },
      "update:isFirstStep": function($event) {
        _vm.isFirstStep = $event
      },
      "update:is-first-step": function($event) {
        _vm.isFirstStep = $event
      },
      "update:secondStepDevices": function($event) {
        _vm.secondStepDevices = $event
      },
      "update:second-step-devices": function($event) {
        _vm.secondStepDevices = $event
      }
    }
  }) : _c('checkout-form', {
    ref: "cardForm",
    attrs: {
      "cardFirstName": _vm.cardFirstName,
      "cardLastName": _vm.cardLastName,
      "creditCardCompleted": _vm.creditCardCompleted,
      "email": _vm.email,
      "isBankDataFilled": _vm.isBankDataFilled,
      "isCreditCard": _vm.isCreditCard,
      "isFirstStep": _vm.isFirstStep,
      "secondStepDevices": _vm.secondStepDevices
    },
    on: {
      "update:cardFirstName": function($event) {
        _vm.cardFirstName = $event
      },
      "update:card-first-name": function($event) {
        _vm.cardFirstName = $event
      },
      "update:cardLastName": function($event) {
        _vm.cardLastName = $event
      },
      "update:card-last-name": function($event) {
        _vm.cardLastName = $event
      },
      "update:creditCardCompleted": function($event) {
        _vm.creditCardCompleted = $event
      },
      "update:credit-card-completed": function($event) {
        _vm.creditCardCompleted = $event
      },
      "update:email": function($event) {
        _vm.email = $event
      },
      "update:isCreditCard": function($event) {
        _vm.isCreditCard = $event
      },
      "update:is-credit-card": function($event) {
        _vm.isCreditCard = $event
      },
      "update:isFirstStep": function($event) {
        _vm.isFirstStep = $event
      },
      "update:is-first-step": function($event) {
        _vm.isFirstStep = $event
      },
      "update:secondStepDevices": function($event) {
        _vm.secondStepDevices = $event
      },
      "update:second-step-devices": function($event) {
        _vm.secondStepDevices = $event
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "mb4 responsive-box",
    class: [(_vm.isPhoneOnly ? 'w-40' : 'w-30'), (_vm.is3cRegistration ? 'dn' : 'db')]
  }, [_c('cart-total-info', {
    attrs: {
      "disabledButton": _vm.secondStepDisabled,
      "filteredPhones": _vm.filteredPhones,
      "hasAgreed": _vm.hasAgreed,
      "isFirstStep": _vm.isFirstStep,
      "isPhoneOnly": _vm.isPhoneOnly,
      "isStudent": _vm.studentQuantity > 0,
      "monthlyToggle": _vm.monthlyToggle,
      "name": _vm.coverageName,
      "onSubmit": _vm.submit,
      "price": _vm.totalPrice,
      "selectedCoverages": _vm.monthlyToggle ? _vm.selectedMonthlyCoverages : _vm.selectedAnnualCoverages,
      "planType": "PHONE"
    },
    on: {
      "update:hasAgreed": function($event) {
        _vm.hasAgreed = $event
      },
      "update:has-agreed": function($event) {
        _vm.hasAgreed = $event
      },
      "update:isFirstStep": function($event) {
        _vm.isFirstStep = $event
      },
      "update:is-first-step": function($event) {
        _vm.isFirstStep = $event
      }
    }
  })], 1)], 1)])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-3f82a91c","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/registration/UnifiedRegistration.vue
// module id = 988
// module chunks = 0